export const NON_AUDI_ADDITIONAL_KEYS = [
  'BODY_STYLE',
  'EXTERIOR_COLOR_GENERIC',
  'INTERIOR_COLOR',
  'INTERIOR_MATERIAL',
  'ENGINE',
  'ENGINE_CYLINDERS',
  'DRIVE_TRAIN',
  'TRANSMISSION',
  'FUEL_TYPE',
  //   'MODEL',
  //   'TRIM',
  //   'BODY_STYLE_NORMALIZED',
  //   'ENGINE_DISPLACEMENT',
  //   'DRIVE_TRAIN_NORMALIZED',
  //   'TRANSMISSION_NORMALIZED',
  'TRANSMISSION_SPEED',
  //   'EXTERIOR_COLOR',
  //   'INTERIOR_COLOR_GENERIC',
  //   'NORMALIZED_FUEL_TYPE',
  'MPG_CITY',
  'MPG_HWY',
  'MPG_COMBINED',
  'BATTERY_CAPACITY',
  'CHARGE_TIME_DETAILS',
  'ELECTRIC_CONSUMPTION',
  'RANGE_ON_SINGLE_CHARGE',
  'NUMBER_OF_ELECTRIC_MOTORS',
  'BATTERY_WARRANTY',
];

export const MPG_KEYS = ['MPG_HWY', 'MPG_CITY', 'MPG_COMBINED'];
